/**
 * Utility function to merge API data with mock data
 * Only uses mock data when API keys don't exist
 * 
 * @param {Object} report - API response data
 * @param {Object} mockData - Mock data object
 * @returns {Object} - Merged data object with API data taking precedence
 */
export const mergeDataWithFallback = (report = {}, mockData = {}) => {
    // Helper function to get value from API or fallback to mock data
    const getValueWithFallback = (apiKey) => {
        // Only use mock data if the key doesn't exist in API response
        if (report.hasOwnProperty(apiKey)) {
            return report[apiKey]; // Show API value even if null/undefined
        }
        return mockData[apiKey]; // Use mock only if key doesn't exist
    };
    
    // Create data object with fallback logic
    const dataWithMock = {};
    
    // Apply fallback logic to all mock data keys
    Object.keys(mockData).forEach(key => {
        dataWithMock[key] = getValueWithFallback(key);
    });
    
    // Add any additional API data that's not in mock data
    Object.keys(report).forEach(key => {
        if (!mockData.hasOwnProperty(key)) {
            dataWithMock[key] = report[key];
        }
    });
    
    return dataWithMock;
};
